<script setup lang="ts">
import { Activiteit } from '@/repositories/activiteit.repository';
import UpcomingActivityCard from './UpcomingActivityCard.vue';
import Swiper from 'swiper';
import { Navigation, EffectFade, Pagination } from 'swiper/modules';
import { computed, nextTick, ref, watch } from 'vue';
import { usePlatformStore } from '@/stores/platform.store';

const platformStore = usePlatformStore();

const props = defineProps<{
    activities: Activiteit[],
    activitySingular: string,
    activityPlural: string,
    sportaanbieder?: string,
}>();

const swiperEl = ref<HTMLElement | null>(null)
const swiperPagination = ref<HTMLElement | null>(null)
const prevEl = ref<HTMLElement | null>(null)
const nextEl = ref<HTMLElement | null>(null)

let swiper: Swiper | null = null

const initSwiper = async () => {
    await nextTick()

    if (!swiperEl.value || swiper) return

    swiper = new Swiper(swiperEl.value, {
        modules: [Navigation, EffectFade, Pagination],
        slidesPerView: 1,
        loop: true,
        spaceBetween: 16,
        navigation: {
            prevEl: prevEl.value!,
            nextEl: nextEl.value!,
        },
        pagination: {
            el: swiperPagination.value!,
            type: "fraction",
            renderFraction: (currentClass, totalClass) => {
                return '<span class="' + currentClass + '"></span>' +
                    '/' +
                    '<span class="' + totalClass + '"></span>'
            }
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 1
            },
            1200: {
                slidesPerView: 2
            }

        }
    })
}

const activitiesUrl = computed(() => {
    if (!platformStore.activiteitenSearchUrl) return undefined;

    if (!props.sportaanbieder) {
        return platformStore.activiteitenSearchUrl;
    }

    return `${platformStore.activiteitenSearchUrl}?id=${props.sportaanbieder}`;
});

watch(
    () => props.activities,
    (val) => {
        if (val?.length) initSwiper()
    },
    { immediate: true }
)
</script>

<template>
    <div class="upcoming-activities">
        <div ref="swiperEl" class="swiper upcoming-activities-swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="activity in activities" :key="activity.SportmomentId">
                    <UpcomingActivityCard :activity="activity" :activity-plural="activityPlural"
                        :activity-singular="activitySingular" />
                </div>
            </div>
        </div>
        <div class="upcoming-activities-swiper-controls">
            <div class="navigation-buttons">
                <button ref="prevEl" class="btn button-prev">
                    <span class="icon icon-arrow--left"></span>
                </button>
                <div ref="swiperPagination" class="custom-pagination"></div>
                <button ref="nextEl" class="btn button-next">
                    <span class="icon icon-arrow--right"></span>
                </button>
            </div>

            <a v-if="activitiesUrl" :href="activitiesUrl" class="btn btn-gray align-items-center d-flex w-fit">
                <span>Ga naar alle {{ activityPlural }}</span>
                <span class="ml-1 icon icon-arrow-right" aria-hidden="true"></span>
            </a>
        </div>
    </div>
</template>
